'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ordinal = require('../ordinal');

var _ordinal2 = _interopRequireDefault(_ordinal);

var _d3Scale = require('d3-scale');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _ordinal2.default)(_d3Scale.schemeCategory10);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@vx/scale/build/scales/color/schemeCategory10.js
// module id = 1294
// module chunks = 0